import axios from "axios";

export const USER_URL = "/User";
export const BRANCH_URL = "/Branch";
export const SECTION_URL = "/Section";
export const PERSONNEL_TYPE_URL = "/PersonnelType";

/** Mevcut Okulun Kullanıcı Grubu Listesini Elde Eder */
export function getUserGroups() {
  return axios.get(`${USER_URL}/GetUserGroups`);
}

/** Mevcut Dönemdeki Belli Bir Personel Kullanıcı Listesini Elde Eder */
export function getPersonnelUsers(queryParams) {
  return axios.post(`${USER_URL}/GetPersonnelUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Personel Kullanıcı Listesini Sayfalama Olmadan Elde Eder */
export function getAllPersonnelUsers(queryParams) {
  return axios.post(`${USER_URL}/GetAllPersonnelUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Öğretmen Kullanıcı Listesini Elde Eder */
export function getTeacherUsers(queryParams) {
  return axios.post(`${USER_URL}/GetTeacherUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Öğretmen Kullanıcı Listesini Sayfalama Olmadan Elde Eder */
export function getAllTeacherUsers(queryParams) {
  return axios.post(`${USER_URL}/GetAllTeacherUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Öğrenci Kullanıcı Listesini Elde Eder */
export function getStudentUsers(queryParams) {
  return axios.post(`${USER_URL}/GetStudentUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Öğrenci Kullanıcı Listesini Sayfalama Olmadan Elde Eder */
export function getAllStudentUsers(queryParams) {
  return axios.post(`${USER_URL}/GetAllStudentUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Veli Kullanıcı Listesini Elde Eder */
export function getParentUsers(queryParams) {
  return axios.post(`${USER_URL}/GetParentUsers`, queryParams);
}

/** Mevcut Dönemdeki Belli Bir Veli Kullanıcı Listesini Sayfalama Olmadan Elde Eder */
export function getAllParentUsers(queryParams) {
  return axios.post(`${USER_URL}/GetAllParentUsers`, queryParams);
}

/** Mevcut Okulun Personel Türü Listesini Elde Eder */
export function getPersonnelTypes() {
  return axios.get(`${PERSONNEL_TYPE_URL}/GetPersonnelTypes`);
}

/** Mevcut Okulun Branş Listesini Elde Eder */
export function getBranches() {
  return axios.get(`${BRANCH_URL}/GetBranches`);
}

/** Mevcut Okulun Şube Listesini Elde Eder */
export function getSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Belli Bir Kullanıcının Sisteme Giriş Yapabileceği IP Listesini Elde Eder */
export function getIPList(id) {
  return axios.get(`${USER_URL}/GetUserIPList/${id}`);
}

/** Mevcut Kullanıcının Kullanıcı Adını Elde Eder */
export function getUsername() {
  return axios.get(`${USER_URL}/GetUsername`);
}

/** Belli Bir Kullanıcı Listesinin Sisteme Giriş Yapabileceği IP Listesini Kaydeder */
export function saveIPList(ids, data) {
  return axios.post(`${USER_URL}/SaveIPList`, { ids, data });
}

/** Mevcut Kullanıcının Kullanıcı Adı ve Şifresini Günceller */
export function updateUsernameAndPassword(usernameAndPassword) {
  return axios.post(`${USER_URL}/UpdateUsernameAndPassword`, usernameAndPassword);
}

/** Belli Bir Kullanıcı Listesinin Aktiflik Durumunu Değiştirir */
export function toggleActiveness(ids) {
  return axios.post(`${USER_URL}/ToggleActiveness`, { ids });
}